import Config from '@config';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import { Settlement, Street } from '@/features/locations/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { FiltersGrid, Pagination } from '../types';
import { infiniteQueryOptions } from '../utils';

export const locationsApi = createApi({
  reducerPath: 'locationsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/locations`,
  }),
  endpoints: builder => {
    return {
      getSettlements: builder.query<Settlement[], { text: string }>({
        query: input => ({
          url: `/settlements?text=${input.text}`,
        }),
      }),
      getStreets: builder.query<
        Street[],
        { settlementId: string; text: string }
      >({
        query: input => ({
          url: `/streets?settlementId=${input.settlementId}&text=${input.text}`,
        }),
      }),
      getBuildingTypesI: builder.infiniteQuery<
        { id: string; name: string }[],
        FiltersGrid | void,
        Pagination
      >({
        infiniteQueryOptions,
        query: ({ queryArg, pageParam }) => {
          return {
            url: `/buildingTypes`,
            params: { ...queryArg, ...pageParam },
          };
        },
      }),
    };
  },
});

export const { useGetSettlementsQuery, useGetStreetsQuery } = locationsApi;

export const useGetBuildingTypesGridifyInfiniteQuery =
  normalizeInfiniteQueryData(locationsApi.useGetBuildingTypesIInfiniteQuery);
